import { render, staticRenderFns } from "./block-to-domains.vue?vue&type=template&id=bed08efe"
import script from "./block-to-domains.vue?vue&type=script&lang=js"
export * from "./block-to-domains.vue?vue&type=script&lang=js"
import style0 from "./block-to-domains.vue?vue&type=style&index=0&id=bed08efe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports